// Drawing App - Professional Brush Presets

import { BrushSettings, BrushPresetType } from './types';

export interface BrushPreset {
  type: BrushPresetType;
  name: string;
  icon: string;
  settings: Partial<BrushSettings>;
}

export const BRUSH_PRESETS: BrushPreset[] = [
  {
    type: 'default',
    name: '기본',
    icon: '●',
    settings: {
      size: 12,
      hardness: 0.8,
      flow: 1.0,
      opacity: 0.8,
      spacing: 0.15,
      jitter: 0,
    }
  },
  {
    type: 'pencil',
    name: '연필',
    icon: '✏',
    settings: {
      size: 3,
      hardness: 1.0,
      flow: 0.6,
      opacity: 0.9,
      spacing: 0.05,
      jitter: 0.15,
    }
  },
  {
    type: 'pen',
    name: '펜',
    icon: '🖊',
    settings: {
      size: 4,
      hardness: 1.0,
      flow: 1.0,
      opacity: 1.0,
      spacing: 0.1,
      smoothing: 3,
      jitter: 0,
    }
  },
  {
    type: 'marker',
    name: '마커',
    icon: '🖍',
    settings: {
      size: 20,
      hardness: 0.3,
      flow: 0.5,
      opacity: 0.6,
      spacing: 0.1,
      jitter: 0,
    }
  },
  {
    type: 'airbrush',
    name: '에어브러시',
    icon: '💨',
    settings: {
      size: 40,
      hardness: 0.1,
      flow: 0.15,
      opacity: 0.7,
      spacing: 0.05,
      jitter: 0,
    }
  },
  {
    type: 'watercolor',
    name: '수채화',
    icon: '💧',
    settings: {
      size: 30,
      hardness: 0.2,
      flow: 0.4,
      opacity: 0.6,
      spacing: 0.08,
      jitter: 0.3,
    }
  },
  {
    type: 'calligraphy',
    name: '캘리그래피',
    icon: '✒',
    settings: {
      size: 12,
      hardness: 0.9,
      flow: 1.0,
      opacity: 1.0,
      spacing: 0.08,
      jitter: 0,
    }
  },
  {
    type: 'crayon',
    name: '크레용',
    icon: '🖍',
    settings: {
      size: 15,
      hardness: 0.7,
      flow: 0.7,
      opacity: 0.85,
      spacing: 0.1,
      jitter: 0.4,
    }
  }
];

export function getPreset(type: BrushPresetType): BrushPreset {
  return BRUSH_PRESETS.find(p => p.type === type) || BRUSH_PRESETS[0];
}

export function applyPreset(currentSettings: BrushSettings, preset: BrushPreset): BrushSettings {
  return { ...currentSettings, ...preset.settings };
}
